import { render, staticRenderFns } from "./MatchSymbolToQuantumNumber.vue?vue&type=template&id=70770f9e&"
import script from "./MatchSymbolToQuantumNumber.vue?vue&type=script&lang=js&"
export * from "./MatchSymbolToQuantumNumber.vue?vue&type=script&lang=js&"
import style0 from "./MatchSymbolToQuantumNumber.vue?vue&type=style&index=0&id=70770f9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSelect,VSimpleTable})
